import Flowcharts from './containers/FlowchartsContainer';

export default Flowcharts;
